import type { EmptyStateProps, PageHeaderProps } from "../types";

export function FocusPageHeader({ title, icon, actions, below }: PageHeaderProps) {
  return (
    <header className="mb-6">
      <div className="flex min-h-9 flex-wrap items-center gap-x-4 gap-y-2">
        <h1 className="flex min-w-0 items-center gap-2.5 text-[24px] font-semibold leading-tight tracking-[-0.02em] text-foreground">
          {icon && <span className="inline-flex shrink-0 text-foreground/60 [&_svg]:size-5">{icon}</span>}
          <span className="truncate">{title}</span>
        </h1>
        {actions && <div className="ml-auto flex items-center gap-1.5">{actions}</div>}
      </div>
      {below && <div className="mt-3.5">{below}</div>}
    </header>
  );
}

export function FocusEmptyState({ message, action }: EmptyStateProps) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-3 px-2.5 py-8">
      <p className="text-[14px] text-muted-foreground">{message}</p>
      {action}
    </div>
  );
}
